export default __webpack_public_path__ + "static/media/pawn_rook_dragon.563e1751.png";